/* eslint-disable no-undef */
var GformUpload = function () {
    document.addEventListener('gform/theme/scripts_loaded', function () {
        if (typeof gform === 'undefined' || typeof gform.addFilter !== 'function') {
            return;
        }

        // Add a filter to Gravity Forms file upload fields in order to change the
        gform.addFilter('gform_file_upload_markup', function (html, file, up) {
            var formId = up.settings.multipart_params.form_id;
            var fieldId = up.settings.multipart_params.field_id;

            return (
                "<span class='gform_file_name'>" +
                file.name +
                "</span><span class='gform_file_delete' onclick='gformDeleteUploadedFile(" +
                formId +
                ', ' +
                fieldId +
                ", this);'>remove</span>"
            );
        });
    });
};

export default GformUpload;
